import { Label } from "../../../label/Label";
import { LabelProps } from "../../../label/LabelProps";
import { Table } from "../../Table";

export class RowCountLabel extends Label {
    protected readonly table: Table;

    constructor(table: Table, props?: Partial<LabelProps>) {
        super({
            text: "0 Results",
            marginLeft: 8,
            fontSize: 16,
            color: "#9E9E9E",
            minWidth: 75,
            visible: false,
            wrap: false,
            ...props
        });
        this.table = table;
    }

    refresh() {
        const count = this.table.filteredRows?.length;
        if (this._designer != null) {
            this.text = "0 Results";
        }
        else if (count === 1) {
            this.text = "1 Result";
        }
        else {
            this.text = `${count} Results`;
        }
    }
}
